export const convertSapToHtmlLinebreaks = (string: string): string => {
    const convertedContent = string.replace(/(\\n)/g, '<br>');

    return convertedContent;
};
